import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'badgeDelivery',
  standalone: true,
})
export class BadgeDeliveryPipe implements PipeTransform {
  private readonly statusColorMap: { [key: string]: string } = {
    logistics: 'text-default',
  };

  transform(status: string): string {
    return status ? this.statusColorMap[status] || 'text-default' : 'text-default';
  }
}
